import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { getInitialLanguageWithURL } from "@/helpers";
import {
  enTranslations,
  frTranslations,
  deTranslations,
  itTranslations,
  esTranslations,
} from "@/locales";

const resources = {
  en: { translation: enTranslations },
  fr: { translation: frTranslations },
  de: { translation: deTranslations },
  it: { translation: itTranslations },
  es: { translation: esTranslations },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    lng: getInitialLanguageWithURL(), // Use URL param first, then browser detection on first visit, stored preference on return
    supportedLngs: ["en", "fr", "de", "it", "es"], // Only allow supported languages
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "sessionStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "i18nextLng",
      lookupSessionStorage: "i18nextLng",
      caches: ["localStorage", "sessionStorage"],
    },
  });

export default i18n;
